import { Box } from '@mui/material';
import SocialMediaCard from './SocialMediaCard';
import { SocialMediaList } from '../../utils/data';

const LoginWith = ({ upItems }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        mt: upItems ? 8 : 10,
        mb: upItems ? 10 : 0,
        width: '100%',
      }}
    >
      <Box sx={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
        {SocialMediaList.map((media) => {
          return <SocialMediaCard key={media.icon} media={media} />;
        })}
      </Box>
    </Box>
  );
};
export default LoginWith;
